import CustomCollectionTableRow from "./CustomCollectionTableRow";
import NoResultsIndicator from "@/widgets/NoResultsIndicator";
import { getSortIndicator } from "@/lib/tableHelpers";
import { useTranslation } from 'react-i18next'

export default function CustomCollectionTable({
  customCollectionsData,
  loading,
  selectedCollection,
  onSelectCollection,
  sortColumn,
  sortDirection,
  onSort,
}) {
  const { t } = useTranslation()
  if (customCollectionsData.length === 0 && !loading) {
    return (
      <NoResultsIndicator
        message={t('customCollections.list.emptyState.title')}
        description={t('customCollections.list.emptyState.description')}
      />
    );
  }

  return (
    <div className="mt-6 overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-300 rounded-lg shadow">
        <thead>
          <tr>
            <th className="py-2 px-4 border-b border-gray-300 text-left w-12">
              <span className="font-semibold text-gray-700">{t('customCollections.list.table.select')}</span>
            </th>
            <th className="py-2 px-4 border-b border-gray-300 text-left">
              <button
                className="flex items-center font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
                onClick={() => onSort("name")}
              >
                {t('customCollections.list.table.name')}
                {getSortIndicator("name", sortColumn, sortDirection)}
              </button>
            </th>
              <th className="py-2 px-4 border-b border-gray-300 text-left">
                <span className="font-semibold text-gray-700">{t('customCollections.list.table.defaultSort')}</span>
              </th>
            <th className="py-2 px-4 border-b border-gray-300 text-left">
              <span className="font-semibold text-gray-700">
                {t('customCollections.list.table.fields')}
              </span>
            </th>
            <th className="py-2 px-4 border-b border-gray-300 text-left">
              <span className="font-semibold text-gray-700">{t('customCollections.list.table.visibleInMenu')}</span>
            </th>
            <th className="py-2 px-4 border-b border-gray-300 text-left">
              <button
                className="flex items-center font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
                onClick={() => onSort("created")}
              >
                {t('customCollections.list.table.created')}
                {getSortIndicator("created", sortColumn, sortDirection)}
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          {customCollectionsData.map((collection) => (
            <CustomCollectionTableRow
              key={collection._id || collection.id}
              collection={collection}
              isSelected={selectedCollection === (collection._id || collection.id)}
              onSelectCollection={onSelectCollection}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
